import React from "react";
import style from "./style.module.scss";
import { useNavigate } from "react-router";

type OperationCardType = {
  icon?: string;
  title: string;
  uri: string;
  className?: string;
};

export const OperationCard = ({
  icon,
  title,
  uri,
  className,
}: OperationCardType) => {
  const navigate = useNavigate();


  return (
    <div
      className={`${style.container} ${className}`}
      onClick={() => navigate(uri)}
    >
      <div className={style.content}>
        {window.innerWidth > 1024 && (
          <div className={style.image_wrapper}>
            <img src={icon} className={style.image} />
          </div>
        )}
        <span className={style.title}> {title} </span>
      </div>
    </div>
  );
};
